<template>
    <transition name="fade">
        <!--
                <div id="us" class="us bg-color--dark" ref="parent">
        -->
        <div v-if="appState === 'sort'" id="us" class="us bg-color--dark" ref="parent">
            <div class="us__wrap">
                <div class="us__logo r fadelogo fadelogo--active">
                    <Icon name="sp/spinepal-logomark" />
                </div>
                <div ref="message" class="us__status">
                    <transition name="fade-slide" mode="out-in">
                        <p :key="current_message" class="animated-text type--p type--p--strong" v-html="current_message"></p>
                    </transition>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * UserSorter
 *
 * Decides where the user should go in the app after the log in
 * For instance if the user hasn't completed the intro flow this will fire the IntroFlow component, otherwise, it will show them the home screen
 *
 * @component
 */
import Icon from "@c/Icon.vue";
export default {
    components: {
        Icon,
    },
    data() {
        return {
            current_message: "Loading user data...",
            initial_message: "Loading user data...",
            messages: {
                silo_data: "First, lets's get all your data together.",
                tos_question: "Have signed the Terms of Use?",
                loading: "Thinking...",
            }
        }
    },
    props: {
        appState: String,
        siloData: Object,
    },
    computed: {
        hasSiloData() {
            return this.siloData === null && this.siloData.user.id === 0 ? false : true;
        },
        hasSignedTerms() {
            return this.siloData.user.stats.has_signed_tou === 'true' ? true : false;
        },
        hasCompletedLoginFlow() {
            return this.siloData.user.stats.has_completed_login_flow === true ? true : false;
        },
        hasCompletedWelcomeTopic() {
            return this.siloData.user.progress[0].status === "complete" ? true : false;
        }
    },
    mounted() {
        window.usersorter = this;
        //this.sortUser();
    },
    watch: {
        appState() {
            if (this.appState === 'sort') {
                this.sortUser();
            } else {
                if (this.current_message !== this.initial_message) {
                    this.current_message = this.initial_message;
                }
            }
        }
    },
    methods: {
        sortUser() {
            console.log('user sorter: sorting the user!!!!');
                setTimeout(() => {
                    if (this.hasSiloData === false) {
                        console.log('user sorter: no silo data');
                        this.current_message = "Looks like something went wrong, let's try again.";
                            setTimeout(() => {
                                this.sortUser();
                                return;
                            }, 2000);
                        return;
                    } else {
                        this.current_message = "Checking progress..."
                        console.log('user sorter: your signed in');
                        setTimeout(() => {
                            if (this.hasSignedTerms === false) {
                                console.log('user sorter: havent signed terms');
                                setTimeout(() => {
                                    console.log('user sorter: showing terms');
                                    this.$emit('updateState', 'terms');
                                    return;
                                }, 1000);
                            } else {
                                this.current_message = "Welcome back to the program!"
                                console.log('user sorter: sending you to home');
                                setTimeout(() => {
                                    this.$emit('updateState', 'home');
                                    /*
                                    setTimeout(() => {
                                        window.home.manualLoadChecks();
                                    }, 1000);
                                    */
                                    return;
                                }, 1000);
                            }
                        }, 2000);
                    }
                }, 2000);

            /*
            if (this.siloData === null && this.siloData.user.id !== 0) {
                console.log('SORTER: no silo data');
                return;
            }
            */
           /*
            if (this.hasSignedTerms == false) {
                console.log("SORTER: user hasn't signed terms, forwarding to terms.");
                this.$emit('updateState', 'terms');
                return;
            }
            */
           /*
            if (this.hasCompletedWelcomeTopic === false) {
                // Launch topic 1
                return;
            }
            */
            /*
            if (this.hasCompletedLoginFlow == false) {
                console.log("SORTER: user hasn't completed login flow, forward to login flow.");
                this.$emit('updateState', 'home');
                return;
            }
            */

            /*
            console.log('SORTER: user has completed all requisites, show home page');
            this.$emit('updateState', 'home');
            return;
            */
        }
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.us {
    position: fixed;
    inset: 0 0 0 0;
    z-index: 10000;
    //background-color: var(--color-sp-green);
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    &:before {
        content: "";
        background-color: var(--color-sp-green);
        position: fixed;
        z-index: -1;
        inset: 0 0 0 0;
        width: 100%;
        height: 100vh;
        opacity: 0.85;
    }
}

.us__wrap {
    max-width: rem(480px);
    margin-inline: auto;
    text-align: center;
    justify-content: center;
    gap: rem(30px);
    padding-top: rem(190px);
}

.us__logo {
    margin-inline: auto !important;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    svg {
        width: rem(180px) !important;
        height: auto !important;
    }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateX(10px); /* starts slightly right */
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-10px); /* exits to the left */
}
</style>